import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import './styles/global.css';
import App from './app/App';

// ── Sentry error monitoring ─────────────────────────────────────────────────
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.REACT_APP_ENV || process.env.NODE_ENV,
    release: process.env.REACT_APP_VERSION || undefined,
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    integrations: [Sentry.browserTracingIntegration()],
  });
}

// ── PostHog analytics ───────────────────────────────────────────────────────
const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com';
if (posthogKey && process.env.NODE_ENV === 'production') {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    autocapture: true,
    capture_pageview: false,
  });
}

// ── Render ──────────────────────────────────────────────────────────────────
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<SentryFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

function SentryFallback() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: "'Montserrat', sans-serif", background: 'var(--khv-bg)' }}>
      <div style={{ textAlign: 'center', maxWidth: 420, padding: 32 }}>
        <div style={{ fontSize: 24, fontWeight: 800, color: 'var(--khv-text-primary)', marginBottom: 12 }}>Something went wrong</div>
        <p style={{ fontSize: 12, color: 'var(--khv-text-secondary)', marginBottom: 24 }}>An unexpected error occurred. Please try refreshing the page.</p>
        <button
          onClick={() => window.location.reload()}
          style={{ padding: '8px 18px', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: 'pointer', border: '1px solid var(--khv-accent)', background: 'var(--khv-accent)', color: 'var(--khv-text-inverse)' }}
        >Refresh Page</button>
      </div>
    </div>
  );
}
